// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"UsageDocumentInfo_buttonsContainer__++2h8","link":"UsageDocumentInfo_link__Xxk0y","description":"UsageDocumentInfo_description__nv-Bj"};